module.exports = __webpack_public_path__ + "img/success.d6c24749.png";